<template>

  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="goBack()">
        <i class="reply icon m-r-5"></i> Veterinários
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">      

      <div class="ui segment">
        <h4 class="ui dividing header">Dados Cadastrais</h4>
        <div class="ui form">          
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Usuário</label>
              <user-picker ref="userPicker" attributes="*" :uppercase="true" @onPick="onPickUser" @onClear="vet.userId = null" />
            </div>    
            <div class="seven wide field">
              <label class="form-label">Nome <span class="red text">*</span></label>
              <input class="uppercase" v-model="vet.name" @blur="vet.name = $toUpperCase($event)">
            </div>                                          
            <div class="five wide field">
              <label class="form-label">E-mail</label>
              <input type="email" v-model="vet.email" @blur="vet.email = $clearEmail($event)">
            </div>         
          </div>
          <div class="fields">                                       
            <div class="four wide field">
              <label class="form-label">Celular</label>
              <input type="tel" v-model="vet.mobile">
            </div>            
            <div class="four wide field">
              <label class="form-label">Telefone</label>
              <input type="tel" v-model="vet.phone">
            </div>            
            <div class="three wide field">
              <label class="form-label">CRMV</label>
              <input type="tel" v-model="vet.crmv">
            </div>   
            <div class="five wide field animated fadeIn">
              <label class="form-label">{{ person == 'F' ? 'CPF' : 'CNPJ' }}</label>
              <the-mask type="tel" :mask="['##.###.###/####-##', '###.###.###-##']" v-model="vet.cgc" />
            </div>            
          </div>
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Dia do Aniversário</label>
              <select-day ref="selectBirthDay" @onChange="onChangeBirthDay" />
            </div>
            <div class="four wide field">
              <label class="form-label">Mês do Aniversário</label>
              <select-month ref="selectBirthMonth" :uppercase="false" @onChange="onChangeBirthMonth" />
            </div>
          </div>
        </div>
      </div>  

      <div class="ui segment form-segment">
        <h4 class="ui dividing header">Endereço</h4>
        <div class="ui form">
          <div class="fields">
            <div class="four wide field animated fadeIn">
              <label class="form-label">CEP</label>
              <the-mask type="tel" :mask="'#####-###'" v-model="vet.zipCode" @blur.native="loadAddressByZipCode()" />
            </div>
            <div class="seven wide field">
              <label class="form-label">Logradouro</label>
              <input class="uppercase" placeholder="Rua, Avenida, Praça, etc." v-model="vet.address" @blur="vet.address = $toUpperCase($event)">
            </div>
            <div class="two wide field">
              <label class="form-label">Número</label>
              <input class="uppercase" v-model="vet.number" @blur="vet.number = $toUpperCase($event)">
            </div>
            <div class="three wide field">
              <label class="form-label">Complemento</label>
              <input class="uppercase" v-model="vet.complement" @blur="vet.complement = $toUpperCase($event)">
            </div>            
          </div>
          <div class="fields">            
            <div class="four wide field">
              <label class="form-label">Bairro</label>
              <input class="uppercase" v-model="vet.district" @blur="vet.district = $toUpperCase($event)">
            </div>
            <div class="seven wide field">
              <label class="form-label">Município</label>
              <input class="uppercase" v-model="vet.city" @blur="vet.city = $toUpperCase($event)">
            </div>
            <div class="five wide field">
              <label class="form-label">Estado</label>
              <select-state ref="selectState" @onChange="onChangeState" />
            </div>                        
          </div>
        </div>
      </div>

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Clínicas</h4>
        
        <div class="ui form">
          <div class="fields">
            <div class="seven wide field">
              <customer-picker ref="customerPicker" @onPick="onPickCustomer" />
            </div>
          </div>
        </div>
        
        <table v-if="hasCustomers" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Município</th>
              <th>Estado</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(customer, index) in vet.customers">
              <td><strong class="mobile-only">Nome: </strong>{{ customer.shortName }}</td>
              <td><strong class="mobile-only">Município: </strong>{{ customer.city }}</td>
              <td><strong class="mobile-only">Estado: </strong>{{ customer.state }}</td>
              <td style="width: 50px;">
                <button class="ui small icon button" @click="vet.customers.splice(index, 1)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhuma clínica associada
        </p>

      </div>

      <div class="m-t-20">
        <button class="ui basic button" @click="goBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving || checkingName }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <can-not-remove-modal ref="canNotRemoveModal" />

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão do veterinário ${vet.name} ?`"  @onYes="onConfirmRemoval()" />

      <yes-no-modal ref="confirmNameModal" :message="confirmNameMessage" @onYes="saveVet()"/>

    </div>
  
  </div>  
  
</template>

<script>
  
  import { TheMask } from "vue-the-mask"
  import { formPage, onlySimavet } from "@/mixins"
  import { CustomerPicker, UserPicker, SelectState, SelectDay, SelectMonth } from "@/components"  
  import VetService from "@/services/vet-service"  
  import ZipCodeService from "@/services/zip-code-service"

  export default {
    
    name: "VetForm",

    mixins: [formPage, onlySimavet],

    data() {
      return {
        creatingTitle: "Novo Veterinário",
        updatingTitle: "Alterar Veterinário",
        indexRoute: "/entries/vets",
        service: new VetService(),
        vet: { customers: [] },        
      }
    },    

    components: {
      CustomerPicker,
      UserPicker,
      SelectState,
      SelectDay,
      SelectMonth,
      TheMask,
    },

    created() {
      
      this.initFormPage()

      if (this.isUpdating)
        this.loadVet()      
    },    

    computed: {

      hasCustomers() {
        return (this.vet.customers.length > 0)
      },

      person() {
        return this.vet.cgc && this.vet.cgc.trim().length > 11 ? "J" : "F"
      },
    },

    methods: {

      async loadVet() {

        this.loading = true

        try {

          this.vet = await this.service.findById(this.$route.params.id)

          if (this.vet.user)
            this.$refs.userPicker.setSelected(this.vet.user)

          this.$refs.selectState.setSelected(this.vet.state)  
          this.$refs.selectBirthDay.setSelected(this.vet.birthDay)
          this.$refs.selectBirthMonth.setSelected(this.vet.birthMonth)

        } catch (error) {          

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onPickUser(user) {
        
        const { name, lastName, email, mobile, phone, zipCode, address, number, complement, district, city, state } = user

        this.vet.name = name.trim().toUpperCase() + " " + lastName.trim().toUpperCase()
        this.vet.email = email
        this.vet.userId = user.id
        this.vet.mobile = mobile
        this.vet.phone = phone
        this.vet.zipCode = zipCode
        this.vet.address = address
        this.vet.number = number
        this.vet.complement = complement
        this.vet.district = district
        this.vet.city = city
        
        this.$refs.selectState.setSelected(state)

        this.vet = this.$cloneObject(this.vet)
      },

      onPickCustomer(customer) {              

        let exists = false

        this.vet.customers.forEach((el) => {
          if (customer.id == el.id)
            exists = true
        })

        if (exists) {
          this.$msg.info("Clínica já associada a esse veterinário")
        } else {
          this.vet.customers.push(this.$cloneObject(customer))
        } 

        this.$refs.customerPicker.clear()
      },

      async loadAddressByZipCode() {

        if (!this.vet.zipCode || this.vet.zipCode.trim().length < 8)
          return
        
        try {

          const data = await ZipCodeService.fetch(this.vet.zipCode)

          if (!data || data.erro)
            return

          this.vet.address = data.logradouro.toUpperCase()          
          this.vet.district = data.bairro.toUpperCase()
          this.vet.city = data.localidade.toUpperCase()

          this.$refs.selectState.setSelected(data.uf)          
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      onChangeState(state) {        
        this.vet.state = state
        this.vet = this.$cloneObject(this.vet)
      },

      onChangeBirthDay(birthDay) {        
        this.vet.birthDay = birthDay
        this.vet = this.$cloneObject(this.vet)
      },

      onChangeBirthMonth(birthMonth) {        
        this.vet.birthMonth = birthMonth
        this.vet = this.$cloneObject(this.vet)
      },

      async onConfirm() {

        if (this.checkingName || !this.validData())
          return

        this.checkingName = true
        this.confirmNameMessage = ""

        try {

          const vets = await this.service.checkVetName(this.vet.name, this.vet.id)

          if (vets.length > 0) {
            
            this.confirmNameMessage = vets.length == 1 ? "Existe um veterinário cadastrado " : `Existem ${vets.length} veterinários cadastrados `
            this.confirmNameMessage += `com o nome ${this.vet.name.trim()}. Confirma a `
            this.confirmNameMessage += this.isCreating ? "criação " : "alteração"
            this.confirmNameMessage += " do veterinário ?"

            this.$refs.confirmNameModal.show()
          
          } else {

            this.saveVet()
          }
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingName = false
        }
      },

      async saveVet() {

        this.saving = true

        try {

          if (this.isCreating) {
            await this.service.create(this.vet)
          } else {
            await this.service.update(this.vet)
          }

          this.$reloadDataTables()

          this.$msg.success(this.isCreating ? "Veterinário criado com sucesso" : "Veterinário atualizado com sucesso")

          this.goBack()

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.vet.name) {
          message = "Informe o nome do veterinário"
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.vet)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          await this.service.remove(this.vet)

          this.$reloadDataTables()

          this.$msg.success("Veterinário excluído com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      }
    },
  }

</script>

